import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Award from '@/views/Award'
import Preview from '@/views/Preview'
import ForceEditView from '@/views/ForceEditView'
import AgentEditView from '@/views/AgentEditView'
import Error from '../views/Error.vue'
import Study from '../views/Study.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/study',
    name: 'Study',
    component: Study
  },
  {
    path: '/award',
    name: 'award',
    component: Award
  },
  {
    path: '/answer/:id',
    redirect: '/preview/:id'
    // name: 'answer',
    // component: Preview
  },
  {
    path: '/preview/:id',
    name: 'preview',
    component: Preview
  },
  {
    path: '/force-edit-view/:id',
    name: 'forceEditView',
    component: ForceEditView
  },
  {
    path: '/agent-edit-view/:id',
    name: 'agentEditView',
    component: AgentEditView
  },
  {
    path: '/error',
    name: 'error',
    component: Error
  }
]

const router = new VueRouter({
  routes
})

export default router
